(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initSlideshow(wrapper) {
      var autoplay    = wrapper.dataset.autoplay === 'true';
      var interval    = parseInt(wrapper.dataset.interval, 10) || 5000;
      var pauseHover  = wrapper.dataset.pauseHover === 'true';
      var transition  = wrapper.dataset.transition || 'fade';

      var slides      = wrapper.querySelectorAll('.hero__slide');
      var dots        = wrapper.querySelectorAll('.hero__slideshow-dot');
      var prevBtn     = wrapper.querySelector('.hero__slideshow-arrow--prev');
      var nextBtn     = wrapper.querySelector('.hero__slideshow-arrow--next');
      var progressBar = wrapper.querySelector('.hero__slideshow-progress-bar');

      // Find the hero content wrapper (slide 1 text/blocks)
      var heroEl       = wrapper.closest('.hero');
      var contentWrap  = heroEl ? heroEl.querySelector('.hero__content-wrapper--slideshow') : null;

      var current     = 0;
      var total       = slides.length;
      var timer       = null;
      var isAnimating = false;

      function goTo(index) {
        if (isAnimating || index === current) return;
        isAnimating = true;

        var prev = current;
        current  = (index + total) % total;

        // Manage exit class for slide transition
        if (transition === 'slide') {
          slides[prev].classList.add('hero__slide--exit');
        }

        slides[prev].classList.remove('hero__slide--active');
        slides[current].classList.add('hero__slide--active');

        // Show/hide slide 1 content blocks
        if (contentWrap) {
          contentWrap.style.opacity   = current === 0 ? '1' : '0';
          contentWrap.style.pointerEvents = current === 0 ? '' : 'none';
        }

        // Update dots
        dots.forEach(function(d, i) {
          d.classList.toggle('hero__slideshow-dot--active', i === current);
        });

        // Reset progress bar
        if (progressBar) {
          progressBar.style.animation = 'none';
          progressBar.offsetHeight; // reflow
          progressBar.style.animation = '';
        }

        var cleanupDelay = transition === 'slide' ? 700 : 800;
        setTimeout(function() {
          if (transition === 'slide') {
            slides[prev].classList.remove('hero__slide--exit');
          }
          isAnimating = false;
        }, cleanupDelay);
      }

      function next() { goTo(current + 1); }
      function prev() { goTo(current - 1); }

      function startTimer() {
        if (!autoplay) return;
        clearInterval(timer);
        timer = setInterval(next, interval);
      }

      function stopTimer() { clearInterval(timer); }

      if (prevBtn) prevBtn.addEventListener('click', function() { prev(); startTimer(); });
      if (nextBtn) nextBtn.addEventListener('click', function() { next(); startTimer(); });

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          goTo(parseInt(this.dataset.dot, 10));
          startTimer();
        });
      });

      if (pauseHover) {
        wrapper.addEventListener('mouseenter', stopTimer);
        wrapper.addEventListener('mouseleave', startTimer);
      }

      // Keyboard navigation
      document.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft')  { prev(); startTimer(); }
        if (e.key === 'ArrowRight') { next(); startTimer(); }
      });

      // Touch/swipe support
      var touchStartX = 0;
      wrapper.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      wrapper.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 40) {
          diff > 0 ? next() : prev();
          startTimer();
        }
      }, { passive: true });

      startTimer();
    }

    function boot() {
      document.querySelectorAll('.hero__slideshow').forEach(initSlideshow);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
